
import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      await fetch('https://readdy.ai/api/form/d693j4nmvg9ih2c79rmg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      setIsSuccess(true);
      setEmail('');
      setTimeout(() => setIsSuccess(false), 5000);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-dark to-black relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-accent-green rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent-green rounded-full blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="bg-dark-secondary border border-dark-border rounded-3xl p-8 sm:p-12 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-accent-green/20 rounded-2xl mx-auto mb-6">
            <i className="ri-mail-send-line text-accent-green text-3xl"></i>
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
            Receba Insights Semanais
          </h2>
          <p className="text-gray-400 mb-8 max-w-xl mx-auto">
            Assine nossa newsletter e receba os melhores conteúdos sobre IA e automação diretamente no seu email
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto" id="newsletter-form" data-readdy-form>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Seu melhor email"
              required
              className="flex-1 bg-dark border border-dark-border rounded-full py-4 px-6 text-white placeholder-gray-500 focus:outline-none focus:border-accent-green/50 transition-colors"
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-accent-green hover:bg-accent-green/90 text-black px-8 py-4 rounded-full font-bold transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
            >
              {isSubmitting ? 'Enviando...' : 'Assinar Grátis'}
            </button>
          </form>

          {isSuccess && (
            <div className="mt-4 text-accent-green text-sm">
              <i className="ri-check-line mr-2"></i>
              Inscrição realizada com sucesso!
            </div>
          )}

          <p className="text-gray-500 text-xs mt-4">
            <i className="ri-shield-check-line mr-1"></i>
            Sem spam. Cancele quando quiser.
          </p>
        </div>
      </div>
    </section>
  );
}
